import { FILTERS, DEFAULT_FILTER_VALUES } from 'goals-reporting-lib/constants/filters';
import { GOAL_TYPE } from 'goals-reporting-lib/constants/goals'; // @ts-expect-error cannot find declaration file

export const MIN_PROGRESS_FILTER_PERCENTAGE = DEFAULT_FILTER_VALUES[FILTERS.PERCENT_PROGRESS].minPercentage;
export const MAX_PROGRESS_FILTER_PERCENTAGE = DEFAULT_FILTER_VALUES[FILTERS.PERCENT_PROGRESS].maxPercentage;
export const ADS_MAX_GOAL_PROGRESS_PERCENTAGE = 99;
export const DEFAULT_GOAL_TYPE = GOAL_TYPE.FIRST_FORM_SUBMISSION;
export const getAdAccountAssetId = adAccount => {
  return `${adAccount.get('network').toLowerCase()}-${adAccount.get('accountId')}`;
};